export default __webpack_public_path__ + "static/media/masked_patient_3_30.572cad42.png";